import { Category, Package } from "@app/types";

/** 5 màu danh mục của bản thiết kế (biến --c-* trong _theme.scss) */
export type Tone = "gl" | "gm" | "rd" | "ai" | "dh";

const TONES: Tone[] = ["gl", "gm", "rd", "ai", "dh"];

/** Danh mục có tên giống bản thiết kế thì dùng đúng màu đó */
const KNOWN: [RegExp, Tone][] = [
  [/giả lập|gia lap/i, "gl"],
  [/gaming|game/i, "gm"],
  [/render/i, "rd"],
  [/\bai\b|machine learning/i, "ai"],
  [/đồ họa|đồ hoạ|do hoa|graphic/i, "dh"],
];

/** Chữ danh mục (tag) */
export const TONE_TAG: Record<Tone, string> = {
  gl: "bg-c-gl-soft text-c-gl",
  gm: "bg-c-gm-soft text-c-gm",
  rd: "bg-c-rd-soft text-c-rd",
  ai: "bg-c-ai-soft text-c-ai",
  dh: "bg-c-dh-soft text-c-dh",
};

/** Màu viền khung và đèn vỏ case, nền ảnh thẻ */
export const toneColor = (tone?: Tone) => (tone ? `var(--c-${tone})` : "var(--brand)");

/**
 * Màu của từng danh mục: theo tên nếu khớp bản thiết kế, còn lại lần lượt theo ngày tạo danh mục
 * (danh mục do admin tạo nên tên bất kỳ). Không theo sort_order để admin đổi thứ tự hiển thị thì màu không đổi.
 */
export const categoryTones = (list: (Pick<Category, "_id" | "name"> & { createdAt?: string })[]) => {
  const map: Record<string, Tone> = {};
  const categories = [...list].sort((a, b) => (a.createdAt || "").localeCompare(b.createdAt || ""));
  const known = categories.map((c) => KNOWN.find(([re]) => re.test(c.name))?.[1]);
  // danh mục tên khác lấy trước các màu chưa có danh mục nào dùng, để 2 danh mục không trùng màu
  const free = [...TONES.filter((x) => !known.includes(x)), ...TONES.filter((x) => known.includes(x))];
  let next = 0;

  categories.forEach((c, i) => {
    map[c._id] = known[i] || free[next++ % free.length];
  });

  return map;
};

/** Màu theo package: package nằm trong danh mục nào (danh mục đầu tiên chứa nó) */
export const packageTones = (
  categories: Pick<Category, "_id" | "name">[],
  itemsByCategory: Record<string, Package[]>
) => {
  const tones = categoryTones(categories);
  const map: Record<string, Tone> = {};

  categories.forEach((c) =>
    (itemsByCategory[c._id] || []).forEach((pkg) => {
      if (!map[pkg._id]) map[pkg._id] = tones[c._id];
    })
  );

  return map;
};
